import Model from 'flarum/common/Model';
export default class FriendshipRequest extends Model {
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  sender = (() => Model.hasOne('sender'))();
  recipient = (() => Model.hasOne('recipient'))();
}
flarum.reg.add('forumaker-friendship', 'common/models/FriendshipRequest', FriendshipRequest);